import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_REQUIREMENT} from '../../metamodel/Concept';

export default class RequirementNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_REQUIREMENT;
	}
}
